import React, { useState } from "react";
import { Box, Card, CardHeader, LinearProgress, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";
import { StatusChip } from "../StatusChip/StatusChip";
import { SpaceBar, More } from "@material-ui/icons";
import { SortableColumnHeader } from "./SortableColumnHeader";
import { LoaderButton } from "../LoaderButton/LoaderButton";
/**
 * Sort order for display on column headers
 * Note: None is necessary as default sort order may be by a column not surfaced in the table.
 * Without it, user would have no way of reverting to default.
 */
export var DataTableSortOrder;
(function (DataTableSortOrder) {
    DataTableSortOrder["Asc"] = "ASC";
    DataTableSortOrder["Desc"] = "DESC";
    DataTableSortOrder["None"] = "";
})(DataTableSortOrder || (DataTableSortOrder = {}));
export var DataTablePagination;
(function (DataTablePagination) {
    DataTablePagination["Infinite"] = "infinite";
    DataTablePagination["Pages"] = "pages";
})(DataTablePagination || (DataTablePagination = {}));
export var DataTable = function (_a) {
    var title = _a.title, columns = _a.columns, data = _a.data, loading = _a.loading, onLoadMore = _a.onLoadMore, error = _a.error, count = _a.count, _b = _a.pagination, pagination = _b === void 0 ? DataTablePagination.Infinite : _b, rowsPerPage = _a.rowsPerPage, page = _a.page, onChangePage = _a.onChangePage, onChangeRowsPerPage = _a.onChangeRowsPerPage, onChangeSort = _a.onChangeSort, _c = _a.NoDataIcon, NoDataIcon = _c === void 0 ? SpaceBar : _c, _d = _a.noDataCTA, noDataCTA = _d === void 0 ? "No data." : _d;
    var classes = useStyles();
    var _e = useState({
        columnIndex: -1,
        dir: DataTableSortOrder.None
    }), sort = _e[0], setSort = _e[1];
    /**
     * Toggle column sorting state
     * Note this does not sort locally as the result would never be accurate for paginated data.
     * Sorting should be from the server response and/or update in the data layer using this component.
     * @param columnIndex
     */
    var toggleSort = function (columnIndex) {
        var newDir = DataTableSortOrder.Asc;
        if (sort.dir === DataTableSortOrder.Asc)
            newDir = DataTableSortOrder.Desc;
        if (sort.dir === DataTableSortOrder.Desc)
            newDir = DataTableSortOrder.None;
        var newSort = { columnIndex: columnIndex, dir: newDir };
        setSort(newSort);
        onChangeSort && onChangeSort(newSort);
    };
    return (React.createElement(Card, null,
        title && React.createElement(CardHeader, { className: classes.header, title: title }),
        React.createElement(TableContainer, null,
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null, columns.map(function (column, i) {
                        if (column.sortable)
                            return (React.createElement(SortableColumnHeader, { key: i, onClick: function () { return toggleSort(i); }, dir: sort.columnIndex === i
                                    ? sort.dir
                                    : DataTableSortOrder.None }, column.label));
                        return React.createElement(TableCell, { key: i }, column.label);
                    })),
                    loading && (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: columns.length, style: { padding: 0 } },
                            React.createElement(LinearProgress, null)))),
                    error && (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: columns.length, style: { padding: 0 } },
                            React.createElement(StatusChip, { type: "error", message: error }))))),
                React.createElement(TableBody, null, (data === null || data === void 0 ? void 0 : data.length) ? data.map(function (row, i) { return (React.createElement(TableRow, { key: i }, row.map(function (row, i) { return (React.createElement(TableCell, { key: i }, row)); }))); })
                    : !error &&
                        !loading && (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: columns.length },
                            React.createElement(Box, { display: "flex", alignItems: "center", flexDirection: "column", m: 2 },
                                React.createElement(NoDataIcon, { color: "primary", style: { fontSize: 100 } }),
                                React.createElement(Box, { mt: 2 }, noDataCTA)))))))),
        pagination === DataTablePagination.Infinite && (React.createElement("div", { className: classes.footer },
            onLoadMore && (React.createElement(LoaderButton, { loading: !!loading, onClick: onLoadMore, variant: "outlined", startIcon: React.createElement(More, null) }, "Load More")),
            count && React.createElement("div", { className: classes.count },
                "Total: ",
                count))),
        pagination === DataTablePagination.Pages && (React.createElement(React.Fragment, null, count && rowsPerPage && onChangePage && onChangeRowsPerPage ? (React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25], component: "div", count: count, rowsPerPage: rowsPerPage, page: page || 0, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage })) : null))));
};
var useStyles = makeStyles(function (theme) { return ({
    header: {
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.primary.contrastText
    },
    footer: {
        display: "flex",
        margin: theme.spacing(1),
        alignItems: "center"
    },
    count: {
        marginLeft: "auto",
        color: theme.palette.text.disabled
    }
}); });
//# sourceMappingURL=DataTable.js.map